module.exports = (Promise.resolve(__parcel__require__("./" + "Doppio.c65da8a3.cf8a8e93.js"))).then(() => parcelRequire('kvo2e'));